import { MODAL_UI } from '@/constants/modals.constants';
import { Carte, Cash, Cheque, Transfer } from '@/assets/icons/Icons';
import {
  ModalConfig,
  PaymentMethod,
  TransactionState,
} from '../type/ModalTypes';
import { IconProps } from '@tabler/icons-react';

const InputStyles = {
  height: MODAL_UI.INPUTS.HEIGHT,
  borderColor: MODAL_UI.INPUTS.BORDER_COLOR.ACCENT,
  borderRadius: MODAL_UI.DIMENSIONS.BORDER_RADIUS,
  '&:focus': {
    borderColor: MODAL_UI.INPUTS.BORDER_COLOR.FOCUSED,
  },
  textAlign: 'center',
  fontSize: MODAL_UI.INPUTS.FONT_SIZE.LARGE,
  padding: MODAL_UI.INPUTS.PADDING.CURRENCY,
};

const OptionalInputStyles = {
  borderColor: MODAL_UI.INPUTS.BORDER_COLOR.DEFAULT,
  borderRadius: MODAL_UI.DIMENSIONS.BORDER_RADIUS,
  '&:focus': {
    borderColor: MODAL_UI.INPUTS.BORDER_COLOR.FOCUSED,
  },
  padding: MODAL_UI.INPUTS.PADDING.NORMAL,
  fontSize: MODAL_UI.INPUTS.FONT_SIZE.NORMAL,
};

const hiddenLabelStyles = {
  display: 'none',
};

const wrapperStyles = {
  small: {
    marginBottom: MODAL_UI.SPACING.SM,
  },
  medium: {
    marginBottom: MODAL_UI.SPACING.MD,
  },
};

const baseButtonRoot = {
  height: MODAL_UI.BUTTONS.HEIGHT,
  borderRadius: MODAL_UI.BUTTONS.BORDER_RADIUS,
  fontWeight: MODAL_UI.BUTTONS.FONT_WEIGHT,
};

export const fields = {
  amount: {
    label: 'amount',
    type: 'number',
    placeholder: 'Montant',
    styles: {
      input: InputStyles,
      label: hiddenLabelStyles,
      wrapper: wrapperStyles.small,
    },
    notice: 'Montant maximum: ',
  },
  remark: {
    label: 'remark',
    placeholder: 'Écrire votre remarque ici',
    styles: {
      input: OptionalInputStyles,
      label: hiddenLabelStyles,
      wrapper: wrapperStyles.medium,
    },
  },
};

export const verifyConfig = {
  choseAdmin:
    'Veuillez choisir un administrateur pour recevoir le code de vérification',
  description: 'Vérifier cette action',
  timeoutLabel: 'Temps restant: ',
  timeoutElapsed: 'Temps écoulé veuillez réessayer .',
  attemptFailed: 'Le Code que vous avez entré est invalide!',
  attemptsLabel: 'Tentatives restantes: ',
  attemptExceeded: 'Tentatives épuisées!',
  label: 'code',
  type: 'number',
  placeholder: 'Code de vérification',
  styles: {
    input: InputStyles,
    label: hiddenLabelStyles,
    wrapper: wrapperStyles.small,
  },
};

export const paymentMethod = [
  { value: 'CASH', label: 'Cash', icon: Cash },
  { value: 'CREDIT_CARD', label: 'Carte bancaire', icon: Carte },
  { value: 'CHECK', label: 'Chèque', icon: Cheque },
  { value: 'TRANSFER', label: 'Virement', icon: Transfer },
] as {
  value: PaymentMethod;
  label: string;
  icon: (props: IconProps) => JSX.Element;
}[];

export const btnConfig = {
  submit: {
    color: 'custom-blue',
    text: 'Valider',
    styles: {
      root: {
        ...baseButtonRoot,
      },
    },
  },
  cancel: {
    text: 'Annuler',
    styles: {
      root: {
        ...baseButtonRoot,
        borderColor: MODAL_UI.BUTTONS.COLORS.OUTLINE.BORDER,
        '&:hover': {
          backgroundColor: MODAL_UI.BUTTONS.COLORS.OUTLINE.BG_HOVER,
        },
      },
    },
  },
  sendCode: {
    text: 'Envoyer le code de vérification',
    styles: {
      root: {
        ...baseButtonRoot,
        width: '100%',
      },
    },
  },
  close: {
    text: 'Fermer',
    styles: {
      root: {
        ...baseButtonRoot,
        width: '100%',
        color: 'white',
      },
    },
  },
  delete: {
    color: 'red',
    text: 'Supprimer',
    styles: {
      root: {
        ...baseButtonRoot,
      },
    },
  },
};

export const modalLabels = {
  CASHOUT: {
    title: 'Décaisser',
    description: 'Veuillez saisir le montant à décaisser',
  },
  REFUND: {
    title: 'Avoir',
    description: 'Créer un Avoir',
    saveLabel:
      "Cette transaction appartient à un autre compte, voulez vous créer cet avoir sur votre compte ou celui d'origine ?",
    saveInOriginalCaisse: "Compte d'origine",
    saveInCurrentCaisse: 'Mon compte',
  },
  REGULARIZE: {
    title: "Régulariser l'impayé",
    description:
      'Veuillez saisir le montant à régulariser et le mode de paiement',
  },
  DELETE: {
    title: 'Supprimer la transaction',
    description: 'Veuillez confirmer la suppression de cette transaction',
  },
  CHANGE_DATE: {
    title: 'Changer date de transaction',
    description: 'Veuillez choisir la nouvelle date de transaction',
  },
};

export const generateModalConfig = (tx: TransactionState) => {
  const config: ModalConfig = {
    amount: ['CASHOUT', 'REGULARIZE', 'REFUND'].includes(tx.type),
    remark: ['CASHOUT', 'REFUND'].includes(tx.type),
    saveOption: !!tx.showWhereToSaveTransaction,
    paymentMethodOption: tx.type === 'REGULARIZE',
    adminOption: !!tx.showOTPVerification,
  };
  if (tx.showOTPVerification) config.remainingAttempt = 3;
  return config;
};
